<template>
<div id="page-clientes" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>

    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="alarm" title="Alertas de Vencimiento" class="elevation-1 px-5 py-3" >
                    <v-card-actions>

                        <v-spacer></v-spacer>
                        <exportar-excel v-tippy style="cursor: pointer" title="Exportar" :data="datafiltered" :exportFields="clientes.camposexcel" name="Clientes.xlsx" >
                            <v-btn x-small fab dark color="success" title="Exportar" v-tippy>
                                <v-icon dark>get_app</v-icon>
                            </v-btn>
                        </exportar-excel>
                    </v-card-actions>
                    
                    <v-dialog v-model="modal" max-width="35%" >
                        <v-card>
                            <v-card-title>
                                <v-card class="primary white--text titulomodal" >
                                    <v-icon @click.native="modal = false" class="white--text" >cancel</v-icon>
                                    <span class="subheading" >
                                        <strong>Actualizar Fecha de Vencimiento: {{rfcSeleccionado}}</strong>
                                    </span>
                                </v-card>                                
                            </v-card-title>
                            <v-form ref="form" lazy-validation>
                                <v-card-text>
                                    <v-container grid-list-md>   
                                            <br/>                                     
                                            <v-row>                                                                                                                                        
                                                <v-col cols=12>
                                                    <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false"  transition="scale-transition" min-width="290px" offset-y>
                                                        <template v-slot:activator="{ on }" >
                                                            <v-text-field v-on="on" v-model="fechaVencimiento" label="Fecha de Vencimiento" color="secondary" prepend-icon="event" 
                                                            @blur="fechaVencimiento = parseDate(fechaVencimiento)" v-mask="'####-##-##'" :rules="[rules.required, validaFecha]" ></v-text-field>
                                                        </template>

                                                        <v-date-picker v-model="fechaVencimiento" color="secondary"  scrollable locale="es-mx" @input="menu1 = false" >
                                                            <v-spacer />

                                                            <v-btn color="secondary" x-small @click="menu1 = false" >
                                                                Cancelar
                                                            </v-btn>
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-col>                                                
                                            </v-row>                                            
                                    </v-container>                                                                                                                                                
                                </v-card-text>
                            </v-form>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn @click.native="modal = false" >
                                    <v-icon>cancel</v-icon> Cancelar
                                </v-btn>
                                <v-btn color="success" @click.native="changeFechaVencimiento()" >
                                    <v-icon>done</v-icon> Actualizar
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <v-card-text>
                        <div id="datagrid" >
                            
                            <v-client-table ref="vuetable" :data="clientes.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                </template>

                                <template slot="estatus" slot-scope="props" >
                                    <div v-if="props.row.to_delete == 1" :style="'text-align:center;'" >Por Eliminar</div>
                                    <div v-else :style="'text-align:center;'" >
                                        <div v-if="props.row.estatus" >Activo</div>
                                        <div v-if="!props.row.estatus" >Inactivo</div>
                                    </div>
                                </template>
                                <template slot="dias" slot-scope="props" >
                                    <span :class="props.row.dias <= 0 ? 'colorRojo' : '' " >
                                        {{ props.row.dias }}
                                    </span>
                                </template>
                                <template slot="fecha_vencimiento" slot-scope="props" >
                                    <span title="Actualizar Fecha" v-tippy @click="setFecha(props.row)" 
                                        style="color:blue;cursor:pointer;text-decoration: underline blue;" >
                                        {{props.row.fecha_vencimiento}}                                         
                                    </span>                                    
                                </template>   
                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial direction="left" open-on-hover :style="'text-align:center;'" >
                                        <template v-slot:activator>
                                            <v-btn x-small fab dark color="primary" >
                                                <v-icon>reorder</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-btn x-small fab dark color="green" v-if="!props.row.estatus" @click.native="
                                            changeEstatus(props.row.id_cliente, true, props.row.grupo)
                                            " title="Activar Cliente" v-tippy>
                                            <v-icon>check</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="orange" v-if="props.row.estatus" @click.native="
                                            changeEstatus(props.row.id_cliente, false, props.row.grupo)
                                            " title="Desactivar Cliente" v-tippy>
                                            <v-icon>block</v-icon>
                                        </v-btn>
                                        
                                    </v-speed-dial>
                                </template>
                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";
import objectRenameKeys from "object-rename-keys";
import moment from "moment"

export default {    
    components: {},
    data() {
        return {
            fab: false,    
            menu1: false,   
            modal: false,
            rfcSeleccionado: "",
            nombreClienteSeleccionado:"",
            fechaVencimiento: "",
            clienteSeleccionado: "",
            rules: {
                required: v => !!v || "Este campo es requerido",         
            },

            name: "datagrid",
            columns: [
                "nombre",
                "identificador",
                "fecha_ingreso", "fecha_vencimiento",                
                "grupo_nombre",
                "estatus",     
                "dias",           
                "actions"
            ],
            show_loading: true,
            options: {
                filterable: ["nombre", "identificador", "fecha_ingreso", "fecha_vencimiento", "grupo_nombre", "estatus", "dias"],
                sortable: ["nombre", "identificador", "fecha_ingreso", "fecha_vencimiento","grupo_nombre", "estatus", "dias"],
                orderBy: { column: 'dias', ascending:true },
                headings: {
                    nombre: "Nombre",
                    identificador: "RFC o TAX ID",
                    fecha_ingreso: "Fecha de Ingreso",
                    fecha_vencimiento: "Fecha de Vencimiento",                    
                    grupo_nombre: "Grupos",
                    estatus: "Estatus",
                    dias:"Días Faltantes para Vencimiento",
                    actions: "Operaciones"
                },
                initFilters: {
                    grupo: "20", //PERIODO DE PRUEBA
                },
                listColumns: {
                    grupo: [],
                    estatus: [{
                            id: true,
                            text: "Activos",
                            default: true,
                        },
                        {
                            id: false,
                            text: "Inactivos"
                        },
                        {
                            id: null,
                            text: "Todos"
                        }
                    ]
                }
            },
            
            breadcrumbs: [{
                    text: "Administración",
                    disabled: false,
                    to: "/admin"
                },
                {
                    text: "Alertas de Vencimiento",
                    disabled: true,
                    href: ""
                }
            ],            
            grupos: [],            
            
            model: {
                id_cliente: "",
                nombre: "",
                grupo: "",
                sistemas: [],
                modulos: [],
                anio_recuperacion: 2012, 
                tipos_empresa: "",
            },
            clientes: {                
                items: [0],
                camposexcel: {
                    Nombre: "nombre",
                    RFC: "identificador",
                    "Fecha de Ingreso": "fecha_ingreso",
                    "Fecha de Vencimiento": "fecha_vencimiento",
                    "Tipo Industria": "tipo_industria",
                    "Ciudad": "ciudad",
                    "Estado": "estado",
                    Grupo: "grupo_nombre",
                    Estatus: "estatus_nombre",
                    "Días Faltantes para Vencimiento":"dias"
                },
            },
            
        };
    },
    computed: {
        datafiltered() {
            if (this.$refs.vuetable != null) {
                return this.$refs.vuetable.allFilteredData;
            } else {
                return this.clientes.items;
            }

        },
    },
    methods: {
        nombre_grupo: function (ids) {
            if (ids && ids.length > 0) {
                let data = this.grupos.filter(item => ids.includes(item.id_grupo));
                if (data.length > 0) return data.map(item => item.nombre).join(", ");
            }
        },
        validaFecha: function(fecha){        
             if (fecha == "Invalid date")
                return "Fecha no válida.";
            else 
              return true;
        },
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },        
        getDiferencia: function(fecha_a){
            if (fecha_a != undefined && fecha_a != ""){
                var inicio = moment(new Date(), "YYYY-MM-DD");
                var fin = moment(fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, 'days')
                if (diferencia>0)
                    diferencia += 1; //Se suma 1 para incluir el día actual
                return diferencia;
            }
            return "N/A";
        },
        getClientes: function () {            
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .get(this.$hostname + "clientes/get_clientes/")
                .then(response => {
                    this.clientes.items = response.data;
                    for (var k in this.clientes.items) {
                        this.clientes.items[k].grupo_nombre = this.nombre_grupo(this.clientes.items[k].grupos);
                        this.clientes.items[k].dias = this.getDiferencia(this.clientes.items[k].fecha_vencimiento);  
                        if (this.clientes.items[k].to_delete == 1 || this.clientes.items[k].to_delete == "1") {
                            this.clientes.items[k].estatus_nombre = 'Por eliminar';
                        } else {
                            this.clientes.items[k].estatus_nombre = this.clientes.items[k].estatus == true ? 'Activo' : 'Inactivo';
                        }
                    }
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los clientes.",
                        footer: ""
                    });
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        setFecha: function(row){
            this.rfcSeleccionado = row.identificador;
            this.nombreClienteSeleccionado = row.nombre;
            this.fechaVencimiento = row.fecha_vencimiento;
            this.clienteSeleccionado = row.id_cliente;
            this.modal = true;

        },
        changeFechaVencimiento: function(){
            if (this.fechaVencimiento != "Invalid date" && this.$refs.form.validate())
                this.$swal({
                    type: "info",
                    title: "Confirme",
                    text: "¿Está seguro de actualizar la fecha de vencimiento del cliente " + this.nombreClienteSeleccionado+" ?",
                    footer: "",
                    showCancelButton: true,
                    cancelButtonColor: "#d33",
                    cancelButtonText: "Cancelar",
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Aceptar",
                    
                }).then(result => {
                    if (result.value){
                        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                        axios
                        .put(this.$hostname + "clientes/update_fecha_vencimiento/", 
                                {id_cliente:this.clienteSeleccionado,fecha_vencimiento: this.fechaVencimiento})
                        .then(response => {
                            this.getClientes();
                        })
                        .catch(error => {
                            console.log(error);
                            this.$root.$dialogLoader.hide();
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al actualizar la fecha del cliente. Favor de comunicarse con soporte.",
                                footer: ""
                            });
                        }).then(()=>{
                            this.modal = false;                            
                            this.rfcSeleccionado = "";
                            this.fechaVencimiento = "";
                            this.clienteSeleccionado = "";
                        });
                    } else {
                        this.modal = false;
                    }                  
                });
        },

        changeEstatus: function (id_cliente, estatus, grupo=null) {
            let texto = estatus ? "activar" : "desactivar";
            this.$swal({
                type: "info",
                title: "Confirme",
                text: "¿Está seguro de " + texto + " el cliente?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                cancelButtonText: "Cancelar",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",                
            }).then(result => {
                if (result.value){
                    let data = {
                        estatus: estatus,
                        id_usuario: this.$local_storage.get("id_usuario"),
                    };
                    if(grupo!=null){
                        data["grupo"] = grupo;
                    }
                    axios.put(this.$hostname + "clientes/" + id_cliente + "/", data)
                    .then(response => {
                        this.getClientes();
                    })
                    .catch(error => {
                        console.log(error);
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al cambiar el estatus al cliente",
                            footer: ""
                        });
                    });
                }                    
            });
        },
        getGrupos: function () {
            try {
                axios
                .get(this.$hostname + "grupos/")
                .then(response => {
                    this.grupos = response.data;
                    let changesMap = {
                        id_grupo: "id",
                        nombre: "text"
                    };
                    this.options.listColumns.grupo = objectRenameKeys(
                        response.data,
                        changesMap
                    );                                               
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los grupos.",
                        footer: ""
                    });
                });
            } catch (error) {
                console.log(error);
            }
            
        },
        
    },
    created: function () {
        this.getClientes();        
        this.getGrupos();          
    },
    beforeCreate: function () {

        if (this.$local_storage.get("tipo_usuario") != "Super Usuario") {
            this.$router.push("/");
            if (this.$local_storage.get("id_cliente") > 0) {
                this.$router.push("/home");
            }
        }

    },
};
</script>
<style scoped>
.elevation-1 >>> .colorRojo {
        color: red !important;
    }
</style>